import React, { MutableRefObject, ReactElement } from 'react'

type Props = {
    inputRef?: MutableRefObject<OnlyNullable<HTMLDivElement>>
}

export const Layout3x2: React.FC<Props> = ({ inputRef }: Props): ReactElement => {
    const props = { ref: inputRef }

    return (
        <div className='layout-3x2' {...props}>
            <svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'>
                <rect
                    className='dashboard-background-1 dashboard-layout-entry-square'
                    x='1.99'
                    y='2'
                    width='8.01'
                    height='12'
                />
                <text
                    className='dashboard-foreground-1 dashboard-layout-entry-text'
                    transform='translate(4.47 10.69) scale(0.94 1)'
                >
                    1
                </text>
                <rect
                    className='dashboard-background-2 dashboard-layout-entry-square'
                    x='11.49'
                    y='2'
                    width='7.8'
                    height='12'
                />
                <text
                    className='dashboard-foreground-2 dashboard-layout-entry-text'
                    transform='translate(13.61 10.69) scale(0.94 1)'
                >
                    2
                </text>
                <rect
                    className='dashboard-background-3 dashboard-layout-entry-square'
                    x='21'
                    y='2'
                    width='7.29'
                    height='12'
                />
                <text
                    className='dashboard-foreground-3 dashboard-layout-entry-text'
                    transform='translate(22.81 10.69) scale(0.94 1)'
                >
                    3
                </text>
                <path className='dashboard-layout-outer-border' d='M28,2V28H2V2H28m2-2H0V30H30V0Z' />
                <line className='central-border-line' x1='10.5' x2='10.5' y2='15' />
                <line className='central-border-line' y1='15' x2='30' y2='15' />
                <line className='central-border-line' x1='20.2' x2='20.2' y2='15' />
                <rect
                    className='dashboard-background-4 dashboard-layout-entry-square'
                    x='1.99'
                    y='16'
                    width='8.01'
                    height='12'
                />
                <text
                    className='dashboard-foreground-4 dashboard-layout-entry-text'
                    transform='translate(4.03 24.69) scale(0.94 1)'
                >
                    4
                </text>
                <rect
                    className='dashboard-background-5 dashboard-layout-entry-square'
                    x='11.49'
                    y='16'
                    width='7.8'
                    height='12'
                />
                <text
                    className='dashboard-foreground-5 dashboard-layout-entry-text'
                    transform='translate(13.63 24.69) scale(0.94 1)'
                >
                    5
                </text>
                <rect
                    className='dashboard-background-6 dashboard-layout-entry-square'
                    x='21'
                    y='16'
                    width='7.29'
                    height='12'
                />
                <text
                    className='dashboard-foreground-6 dashboard-layout-entry-text'
                    transform='translate(22.98 24.67) scale(0.94 1)'
                >
                    6
                </text>
                <line className='central-border-line' x1='10.5' y1='14' x2='10.5' y2='29' />
                <line className='central-border-line' x1='20.2' y1='14' x2='20.2' y2='29' />
            </svg>
        </div>
    )
}
